import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Label } from "@/components/site/Motion";
import { useSettings } from "@/hooks/useSettings";

export function CTASection() {
  const s = useSettings();
  return (
    <section className="relative grain overflow-hidden bg-navy text-white">
      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-8 py-24 lg:py-32">
        <div className="grid gap-10 md:grid-cols-12 items-end">
          <div className="md:col-span-8">
            <Label>Start your project</Label>
            <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-balance">
              Let's build something that outlives us.
            </h2>
            <p className="mt-6 max-w-xl text-white/60 leading-relaxed">
              Book a free consultation with our team and get a transparent
              estimate for your construction, interior or furniture project.
            </p>
          </div>
          <div className="md:col-span-4 flex md:justify-end">
            <Link
              to="/contact"
              data-testid="cta-contact-btn"
              className="group inline-flex items-center gap-3 rounded-sm bg-gold px-8 py-4 text-navy font-medium hover:bg-white transition-colors duration-300"
            >
              Request a quote
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-8">
          <Stat value={s.years_experience} label="Years of experience" />
          <Stat value={s.projects_completed} label="Projects completed" />
          <Stat value={s.rating} label="Google rating" />
          <Stat value="Lucknow" label="Based in U.P., India" />
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <Reveal>
      <div className="font-display text-3xl md:text-4xl text-gold">{value}</div>
      <div className="mt-2 text-xs uppercase tracking-[0.2em] text-white/50">{label}</div>
    </Reveal>
  );
}

export function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-40 pb-20 lg:pt-48 lg:pb-28 overflow-hidden bg-navy-deep text-white grain">
      {image && (
        <div className="absolute inset-0 z-0">
          <img src={image} alt={title} className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-navy-deep/60" />
        </div>
      )}
      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-8">
        <Label>{eyebrow}</Label>
        <h1 className="mt-5 font-display text-5xl md:text-6xl lg:text-7xl font-medium tracking-tighter leading-none text-balance max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-8 max-w-2xl text-lg text-white/60 leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
